import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { redirectMapper } from 'data-source/mappers/redirectMapper'
import { TeamMemberMapperOpts } from 'data-source/mappers/teamMemberMapper'
import { DSAuthorNewPage, DSRedirect } from 'shared-definitions/types'
import { ApiNewAuthorPageProps, ApiResponse, ApiResponseRedirect } from '../types.wp'
import { imageMapper } from './imageMapper'
import { onePostWithAuthorMapper, OnePostWithAuthorMapperOpts } from './onePostWithAuthorMapper'
import { paginationMapper } from './paginationMapper'
import { socialsMapper } from './socialsMapper'

interface CodecGetAuthorPageOpts
  extends MetaMapperOpts,
    TeamMemberMapperOpts,
    OnePostWithAuthorMapperOpts {
  pagePath: string
  slug: string
}

export function codecGetAuthorNewPage(
  raw: ApiResponse<ApiNewAuthorPageProps> | ApiResponseRedirect,
  opts: CodecGetAuthorPageOpts
): DSAuthorNewPage | DSRedirect | null {
  if ('redirect' in raw) {
    return redirectMapper(raw)
  }
  if (!('data' in raw) || !('content' in raw.data)) {
    return null
  }

  const input = raw.data
  return {
    slug: opts.slug,
    sections: null,
    ampPagePath: null,
    head: headPropsMapper(input.head),
    meta: metaMapper({ ...input, content: {} }, [], opts),
    pagePath: opts.pagePath,
    resource: 'author-new-page',
    author: {
      name: input.content.author.name,
      description: input.content.author.description,
      image: imageMapper(input.content.author.image, opts),
      socials: socialsMapper(input.content.socials),
    },
    posts: {
      ...paginationMapper(input.content.latest_posts),
      items: input.content.latest_posts.posts.map(i => onePostWithAuthorMapper(i, opts)),
    },
    numbers: input.content.statistics.map(i => ({
      title: i.title,
      subTitle: i.text,
      icon: i.image,
    })),
    choice:
      input.content.current_headphones_choice_image &&
      input.content.current_headphones_choice !== ''
        ? {
            title: input.content.current_headphones_choice_title,
            image: imageMapper(input.content.current_headphones_choice_image, opts),
            short: input.content.current_headphones_choice,
          }
        : null,
    labels: {
      connect: input.content.socials_title,
      recentArticles: input.content.latest_posts_title,
    },
  }
}
